/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Trabaja from "./Componentes/Home_Trabaja";
import Home_Bienvenido from "./Componentes/Home_Bienvenido";
import Home_Profesionales from "./Componentes/Home_Profesionales";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import Home_Espacios from "./Componentes/Home_Espacios";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";
import Home_Blog from "./Componentes/Home_Blog";
import {SECCIONES} from "../../Constantes";

const Seccion_Home = () => {
    const {sCell} = useResponsive()

    useEffect(() => {
        irArriba()
    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid id={'espacios'} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                {/*
                <Home_Portada/>
                */}

                <Home_Espacios/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                {/*
                <Home_Servicios/>
                */}
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Trabaja/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 8 : 12}}>
                <Home_Bienvenido/>
            </Grid>

            <Grid  id={SECCIONES[2]}container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                  <Home_Profesionales/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Testimonios/>
            </Grid>

            <Grid id={SECCIONES[1]} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Blog/>
            </Grid>



        </Grid>
    )

}
export default Seccion_Home